module.exports = __webpack_public_path__ + "static/SuisseIntl-SemiBold-4c66b7d1217305d23e80532aa22822f3.woff";